import { userTypes } from "../constantes/actionTypes"

const initialState = {}

export const userProfile = (state = initialState, action) => {
  switch (action.type) {
      case userTypes.LOGIN_SUCCESS:
          return action.payload
      case userTypes.LOGIN_FAILURE:
          return initialState
      case userTypes.LOGOUT:
          return initialState
      default:
          return state
  }
}
